import { cn } from 'lib/utils'
import { Checkbox as ShadCB } from './base/checkbox'
import { Label } from './label'

export const Checkbox = ({
  id,
  label,
  name,
  onChange,
  value,
  className,
  labelClassName,
  checkboxClassName,
  helperText,
  helperTextClassName,
  ...props
}: {
  id?: string
  label: string | React.ReactNode
  name: string
  onChange: (checked: boolean) => void
  value: boolean
  className?: string
  labelClassName?: string
  checkboxClassName?: string
  helperText?: string
  helperTextClassName?: string
} & Omit<
  React.ComponentPropsWithoutRef<typeof ShadCB>,
  'onChange' | 'onCheckedChange' | 'checked' | 'value' | 'name' | 'className' | 'id'
>) => (
  <div className="flex flex-col gap-1">
    <div className={cn('flex items-center', className)}>
      <ShadCB
        id={id}
        {...props}
        name={name}
        onCheckedChange={onChange}
        checked={value}
        className={cn('shadow-none', checkboxClassName)}
      />
      <div className="flex flex-col gap-1">
        <Label className={cn('ml-2', labelClassName)} htmlFor={id ?? name}>
          {label}
        </Label>
      </div>
    </div>
    {helperText && (
      <Label
        className={cn('ml-6 text-p-400 text-secondary', helperTextClassName)}
        htmlFor={id ?? name}
      >
        {helperText}
      </Label>
    )}
  </div>
)
